<!-- 组建一个页面，它负责渲染一个Tab页面  -->
<!-- 接收一个Tab对象，对这个Tab对象进行操作 -->
<template>
  <draggable class="dragArea" :list="mComponentListConfig" item-key="index" animation="300" @start="onStart"
    @end="onEnd" filter=".bottom">
    <template #item="{ element }">
      <div class="component-box" @click="handleSelectComponent($event, element)">

        <!-- 组件标题 -->
        <div class="controller-title">
          {{ element.name }}
        </div>

        <!-- 组件删除 -->
        <div class="controller-aside">
          <el-icon class="button-remove" @click="handleDeleteComponent($event, element)">
            <Delete />
          </el-icon>
        </div>

        <!--不同类型组件-->
        <BannerView v-if="element.type == 'banner'" :obj="element" />
        <SearchBarView v-else-if="element.type == 'searchbar'" :obj="element" />
        <WordBannerView v-if="element.type == 'word_banner'" :obj="element" />

        <!-- <BottomListView v-if="isBottomList(element.type)" :obj="element" class="bottom" /> -->
        <BottomListAvatarView v-if="element.type == 'bottom_list_avatar'" :obj="element" class="bottom" />
        <BottomListEmojiView v-if="element.type == 'bottom_list_emoji'" :obj="element" class="bottom" />
        <BottomListWallpaperView v-if="element.type == 'bottom_list_wallpaper'" :obj="element" class="bottom" />
        <BottomListThemeView v-if="element.type == 'bottom_list_theme'" :obj="element" class="bottom" />
        <BottomListPhotoTagsView v-if="element.type == 'bottom_list_phototags'" :obj="element" class="bottom" />
        <BottomListTagsAndPhotosView v-if="element.type == 'bottom_list_tagsandphotos'" :obj="element" class="bottom" />
        
        
        <PhotoClassifyLineView v-if="element.type == 'photo_classify_line'" :obj="element" />
        <PhotoClassifyLineTinyView v-if="element.type == 'photo_classify_line_tiny'" :obj="element" />
        <PhotoClassifyLineLittleView v-if="element.type == 'photo_classify_line_little'" :obj="element" />
        <PhotoClassifyView v-if="element.type == 'photo_classify'" :obj="element" />
        <PhotoClassifyPlatView v-if="element.type == 'photo_classify_plat'" :obj="element" />
        <TagPhotosView v-if="element.type == 'tag_photos'" :obj="element" />
        <!--边框-->
        <div
          :class="['component-widget', currentComponent == element ? 'component-widget-select' : 'component-widget-normal']">
        </div>
      </div>
    </template>
  </draggable>
</template>
  
<script>
import draggable from 'vuedraggable'
import BannerView from '@/views/Decoration/DecorationGroup/Banner/BannerView.vue';
import SearchBarView from '@/views/Decoration/DecorationGroup/SearchBar/SearchBarView.vue';
import WordBannerView from '@/views/Decoration/DecorationGroup/WordBanner/WordBannerView.vue';
import BottomListView from '@/views/Decoration/DecorationGroup/BottomList/BottomListView.vue';
import PhotoClassifyLineView from '@/views/Decoration/DecorationGroup/PhotoClassifyLine/PhotoClassifyLineView.vue';
import PhotoClassifyLineTinyView from '@/views/Decoration/DecorationGroup/PhotoClassifyLineTiny/PhotoClassifyLineTinyView.vue';
import PhotoClassifyLineLittleView from '@/views/Decoration/DecorationGroup/PhotoClassifyLineLittle/PhotoClassifyLineLittleView.vue';
import PhotoClassifyView from '@/views/Decoration/DecorationGroup/PhotoClassify/PhotoClassifyView.vue';
import PhotoClassifyPlatView from '@/views/Decoration/DecorationGroup/PhotoClassifyPlat/PhotoClassifyPlatView.vue';
import TagPhotosView from '@/views/Decoration/DecorationGroup/TagPhotos/TagPhotosView.vue';

import BottomListAvatarView from '@/views/Decoration/DecorationGroup/BottomListAvatar/BottomListAvatarView.vue';
import BottomListEmojiView from '@/views/Decoration/DecorationGroup/BottomListEmoji/BottomListEmojiView.vue';
import BottomListWallpaperView from '@/views/Decoration/DecorationGroup/BottomListWallpaper/BottomListWallpaperView'
import BottomListThemeView from '@/views/Decoration/DecorationGroup/BottomListTheme/BottomListThemeView'
import BottomListPhotoTagsView from '@/views/Decoration/DecorationGroup/BottomListPhotoTags/BottomListPhotoTagsView'
import BottomListTagsAndPhotosView from '@/views/Decoration/DecorationGroup/BottomListTagsAndPhotos/BottomListTagsAndPhotosView'

import emitter from '@/utils/eventbus';
import { Delete } from '@element-plus/icons-vue';

export default {
  name: "ContentPageView",
  components: {
    Delete,
    draggable,
    BannerView,
    SearchBarView,
    WordBannerView,
    BottomListView,
    PhotoClassifyLineView,
    PhotoClassifyLineTinyView,
    PhotoClassifyLineLittleView,
    PhotoClassifyView,
    PhotoClassifyPlatView,
    TagPhotosView,
    BottomListAvatarView,
    BottomListEmojiView,
    BottomListWallpaperView,
    BottomListThemeView,
    BottomListPhotoTagsView,
    BottomListTagsAndPhotosView
  },
  props: ['component_list_config'],
  data() {
    return {
      mComponentListConfig: this.component_list_config,
      currentComponent: {}//当前选中的组件
    }
  },
  methods: {
    /**
     * 删除一个组件
     */
    handleDeleteComponent(event, element) {
      console.log('handleDeleteComponent', element, this.mComponentListConfig)
      const index = this.mComponentListConfig.indexOf(element)
      this.mComponentListConfig.splice(index, 1)
    },
    /*
     * 选中一个组件
     */
    handleSelectComponent(event, component) {
      console.log('handleSelectComponent')
      emitter.emit('onComponentChange', component)
      this.currentComponent = component
    },
    /**
     * 点击大屏
     */
    handleClickWallpaperList() {
      console.log('handleClickWallpaperList', this.tab.wallpaper_list_config)
      emitter.emit('onComponentChange', { name: "大屏", type: "wallpaper_list", component: this.tab.wallpaper_list_config })
    },
    onStart() {

    },
    onEnd() {

    },
    /**
      * 判断是否是底部列表
      */
    isBottomList(type) {
      return type.indexOf('bottom_list') == 0
    }
  },

  watch: {
    component_list_config(newValue) {
      // console.log('component_list_config 更新啦')
      this.mComponentListConfig = newValue
    }
  }
}
</script>
  
<style scoped lang="less">
.dragArea {
  width: 100%;
  height: 100%;
  overflow-y: overlay;
  // overflow-x: hidden;
}

/*滚动条整体样式,高宽分别对应横竖滚动条的尺寸*/
.dragArea::-webkit-scrollbar {
  width: 0px;
  height: 2px;
  border-radius: 5px;
  background-color: #eee;
}

/*滚动条里面小方块*/
.dragArea::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);
}

/*滚动条里面轨道*/
.dragArea::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}


.wallpaper-list_box {
  width: 100%;
  height: 100%;
  text-align: center;
}

.component-box {
  position: relative;

  //组件标题
  .controller-title {
    position: absolute;
    right: 100%;
    top: 0px;
    height: 32px;
    line-height: 32px;
    background: rgba(107, 81, 81, 0.4);
    border-radius: 16px;
    padding: 0 16px;
    word-break: keep-all;
    white-space: nowrap;
    font-size: small;
    transform: translateX(-8px);
    color: #6B7075;
  }

  // 删除组件
  .controller-aside {
    position: absolute;
    // left: 100%;
    right: 0;
    padding-left: 8px;
    z-index: 999;

    .button-remove {
      outline: none;
      border: none;
      width: 30px;
      height: 30px;
      background: #fff;
      box-shadow: -1px 2px 6px 0px rgba(188, 195, 206, 1);
      border-radius: 30px;
      cursor: pointer;
      color: #AEB1B3;

      &:hover {
        color: skyblue;
      }
    }
  }
}


// 组件选中样式
.component-widget {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
}

.component-widget-select {
  border: rebeccapurple solid 2px;
}

.component-widget-normal {
  border: transparent solid 2px;
}

.component-widget-normal:hover {
  border: rebeccapurple dashed 2px;
}

.bottom {}
</style>